import {Apollo} from 'apollo-angular';
import {Injectable} from '@angular/core';
import {ALLVISITAS, CREARVISITA, INFOCREARVISITAS, VISITA} from '../queries/visitas.query';
import {getLoginUser} from '../../CoreModule/services/usuario.services';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {Observable} from 'rxjs';
import {ResultadoModel} from '../models/resultado.model';
import {VisitaModel} from '../models/visita.model';
import {visit} from 'graphql';
import {HttpClient} from '@angular/common/http';
import {PATHFOTOSRVG} from '../../variables';
import {map} from 'rxjs/operators';

@Injectable()
export class VisitaServices {

  public obsSendVisita: Observable<any>;
  public obsSaveResult: Observable<any>;
  public obsSaveEncabezado: Observable<any>;
  public obsVisCerrada: Observable<any>;

  constructor(private apollo: Apollo, private ss: SocketServices, private http:HttpClient) {
    this.obsSendVisita = this.ss.registrarEvento('sendVisita');
    this.obsSaveResult = this.ss.registrarEvento('updRespuesta');
    this.obsVisCerrada = this.ss.registrarEvento('visCerrada');
    this.obsSaveEncabezado = this.ss.registrarEvento("updEncabezado");
  }

  crearVisitas(plantilla: any, tiendas: any[], periodoVisitas:string) {
    return this.apollo.mutate({
      mutation: CREARVISITA,
      variables: {
        plantilla: plantilla,
        tiendas: tiendas,
        periodoVisitas: periodoVisitas,
        idUser: getLoginUser()
      }
    });
  }

  getVisita(id: any) {

    this.ss.enviarEvento('getVisita', {id: id});
    // return this.apollo.query({
    //   query: VISITA,
    //   variables: {
    //     id: id
    //   }
    // });
  }


  getAllVisitas() {


    return this.apollo.query({
      query: ALLVISITAS,
      variables: {
        idUser: getLoginUser()
      }
    });
  }

  getInfoCrearVisitas() {
    return this.apollo.query({
      query: INFOCREARVISITAS,
      variables: {
        idUser: getLoginUser()
      }
    });
  }

  finalizarVisita(id) {
    this.ss.enviarEvento('finVisita', {id: id});
  }

  saveResultado(visita: string, pregunta: string, resultado: ResultadoModel) {
    this.ss.enviarEvento('saveResultado', {visita: visita, pregunta: pregunta, resultado: JSON.stringify(resultado)});
  }



  saveEncabezado(visita:VisitaModel){
    this.ss.enviarEvento('saveEncabezado',{
      visita:visita._id,
      encabezado:{
        lider:visita.lider,
        consultora: visita.consultora,
        // consultor: visita.consultor,
        clientesEnTienda:visita.clientesEnTienda,
        fechaVisita:visita.fechaVisita,
        gerente: visita.gerente,
        observacionesGenerales: visita.observacionesGenerales
      }
    })
  }

  subirFoto(file:File, idVis:string, respuesta:ResultadoModel){
    const formData: FormData = new FormData();
    formData.append('foto',file,file.name);
    formData.append('visita',idVis);
    formData.append('pregunta', respuesta.pregunta);

    return this.http.post(PATHFOTOSRVG, formData).pipe(map((res:any)=>res));
  }

}
